export default __webpack_public_path__ + "static/media/pendant.75b903e0.webp";